import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = `${environment.baseUrl}/users`; // Adjust your endpoint

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }

  getAllUsers() {
    // debugger;
    console.log(`${this.apiUrl}/getAllUsersforUI`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getAllUsersforUI`);
    //return this.http.get(`${this.apiUrl}/getAllUsersforUI`);
  }

  // getAllUsers(): Observable<any> {
  // return this.http.get(`${environment.apiUrl}/users/getAllUsersforUI`);
  //}

  addUser(data: any) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {

        "username": data.username,
        "loginid": data.loginid,
        "password": data.password,
        "user_type": data.user_type,

        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/addUser`, body);
    //return this.commonAPI.postApiCall(`${this.apiUrl}/addUser`, data);
    // return this.http.post(`${this.apiUrl}/addUser`, data);
  }

  changeRole(data: any) {
    //userid, user_type
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {

        "userid": data.userid,
        "user_type": data.user_type,

        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/changeRole`, body);
    // return this.http.post(`${this.apiUrl}/changeRole`, data);
  }

  changeStatus(data: any) {
    //userid, user_status,

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {

        "userid": data.userid,
        "user_status": data.user_status,

        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/changeStatus`, body);
  }

  assignSmeCustomerLicenses(data: {
    userId: number;
    CustomerShortCode: string;
    assignedLicenses: number | null;
  }) {
    const body = {
      criteria: {
        userId: data.userId,
        CustomerShortCode: data.CustomerShortCode,
        assignedLicenses: data.assignedLicenses,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/assignSmeCustomerLicenses`, body);
  }
}
